import gql from 'graphql-tag';
import { sessionReportScoreFieldsFragment } from './sessionReportScoreFieldsFragment';

export const sessionReportSummaryInfoScoreAggregateFieldsFragment = gql`
  fragment AdminSessionReportSummaryInfoScoreAggregateFields on SessionReportSummaryInfoScoreAggregate {
    name
    score {
      ...AdminSessionReportScoreFields
    }
  }

  ${sessionReportScoreFieldsFragment}
`;